@import 'styles/mixins';
@import 'styles/variables';

.toolbar {
  margin: 10px 7px;
}

.proseInputContainer {
  @include transition;
  border: 1px solid $grey-10;
  border-radius: 6px;

  @include for-phone-only {
    min-height: 100px;
  }

  .proseInput {
    margin: 8px 12px;
    caret-color: var(--focus-50);
  }

  &.focused {
    border: 1px solid var(--focus-50);
    box-shadow: 0px 0px 0px 3px var(--focus-10);
  }
}
